export const BASE_URL = "https://fair-gold-cobra-cape.cyclic.app";
// export const BASE_URL = "http://localhost:8080";
